import { render, staticRenderFns } from "./Assist.vue?vue&type=template&id=61bb4d54&scoped=true&"
import script from "./Assist.vue?vue&type=script&lang=js&"
export * from "./Assist.vue?vue&type=script&lang=js&"
import style0 from "./Assist.vue?vue&type=style&index=0&id=61bb4d54&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61bb4d54",
  null
  
)

export default component.exports